import React, { useState, useEffect, memo, useContext } from 'react';
import { PayPalButton } from "react-paypal-button-v2";
import Axios from 'axios';
import { LoadingContext } from '../../contexts/loadingContext';

const Paypal = memo((props) => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ paymentSettings, setPaymentSettings ] = useState({});
  const [ chargeDetail, setChargeDetail ] = useState({});
  const [ schedule, setSchedule ] = useState(null);
  const [ formURL, setFormURL ] = useState('');
  const { 
    showErrorToastr, 
    successCreateAppointment, 
    populateFormData, 
    createNewAppointmentAPI, 
    changeShowConfirmationComponent, 
    changeIsLoading, 
    getScheduleCreated,
    isLoadingForm
  } = props;

  const { showLoading, hideLoading } = useContext(LoadingContext);

  useEffect(() => {
    showLoading();
  }, 
  // eslint-disable-next-line
  []);

  useEffect(() => {
    if(!props.isLoading){
      setIsLoading(props.isLoading)
    }
    else{
      setIsLoading(true);
    }
    setChargeDetail(props.chargeDetail);
    setPaymentSettings(props.paymentSettings);
    setFormURL(props.formURL);
  },[props.isLoading, props.amount, props.chargeDetail, props.paymentSettings, props.formURL]);

  useEffect(() => {
    setSchedule(props.schedule);
  }, [props.schedule])

  useEffect(() => {
    if(isLoadingForm !== null){
      // setIsLoading(isLoadingForm)
    }
  }, [isLoadingForm])

  useEffect(() => {
    if(isLoading){
      showLoading();
      changeIsLoading(true);
    }
    else{
      hideLoading()
      changeIsLoading(false);
    }
    // eslint-disable-next-line
  }, [isLoading])

  const checkFormFields = () => {
    let allAreFilled = true;
    document.getElementById("form-submit").querySelectorAll("[required]").forEach(function(i) {
        if (!allAreFilled) return;
        if (!i.value){ 
          allAreFilled = false;
          return;
        };
        if (i.type === "radio") {
          let radioValueCheck = false;
          document.getElementById("form-submit").querySelectorAll(`[name=${i.name}]`).forEach(function(r) {
            if (r.checked) radioValueCheck = true;
          })
          allAreFilled = radioValueCheck;
        }
    })
    
    if (!allAreFilled) {
        return false;
    }
    
    return true;
  };

  const countAmountValue = () => {
    return `${(Number(paymentSettings.price)/100).toFixed(2)}`
  };

  const paypalOnClick = async (data, actions) => {
    // change isLoading state
    await changeIsLoading(true);
    setIsLoading(true);
    // check input fields required are all inserted
    let isValid = checkFormFields();

    if(isValid) {
      const data = populateFormData();
      // add charge
      data['charge'] = { type: 'paypal'};

      let result = await createNewAppointmentAPI(data);

      if(result && result['status'] === 'success'){
        return actions.resolve();
      }
      else{
          // setIsLoading(false);
          errorCreateAppointment(result['response']);
          return actions.reject();
      }
    }
    else {
      setIsLoading(false);
      await showErrorToastr('Fields cannot leave blank!');
      return actions.reject();
    }
  };

  const paypalCreateOrder = (data, actions) => {
    // A function called to create order for paypal data

    return actions.order.create({
        intent: 'CAPTURE',
        purchase_units: [{
            amount: {
                currency_code: paymentSettings.currency_code.toUpperCase(),
                value: countAmountValue()
            }
        }],
        application_context: {
            shipping_preference: "NO_SHIPPING" // default is "GET_FROM_FILE"
        }
    });
  };

  const paypalSuccess = async (details, paypalData) => {
    if(schedule && schedule.hash_id){
        // Update schedule status to 'scheduled'
        let schedules = {};
        schedules['external_lead_ids'] = {
            paypal:{
                data: paypalData,
                details: { 
                    create_time: details.create_time,
                    updated_time: details.updated_time,
                    id: details.id,
                    intent: details.intent,
                    payer: {
                        name: details.payer.name,
                        email_address: details.payer.email_address,
                        payer_id: details.payer.payer_id
                    },
                    status: details.status
                }
            }
        };

        let api_url = `${formURL}/`+schedule.hash_id;

        await Axios({
          url: api_url,
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          data: { schedules: schedules, schedule_id: schedule.hash_id }
        })
        .then((response) =>{
          changeShowConfirmationComponent();
          successCreateAppointment();
          changeIsLoading(false);
          hideLoading();
        })
        .catch(error => {
          showErrorToastr(error.message)
        })
    }
    else{
        // error
        showErrorToastr('Error in creating schedule.');
    }
  }

  const errorPaypalPayment = (data) => {
    // delete schedule
    deleteSchedule();
    showErrorToastr(data.err);
    setIsLoading(false);
  }

  const cancelPaypalPayment = (data) => {
    setIsLoading(false);
    // delete schedule
    deleteSchedule();
    showErrorToastr('You need to proceed the payment to continue.');
  };

  const deleteSchedule = async() => {
    let schedule = getScheduleCreated();
    if(schedule && schedule.hash_id){
        let api_url = `${formURL}/`+schedule.hash_id;

        await Axios({
          url: api_url,
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          data: { schedule_id: schedule.hash_id }
        })
        .catch(error => {
            showErrorToastr(error.message)
        })
    }
  };


  const errorCreateAppointment = (data) => {
    showErrorToastr(data['message']);
  };

  if(Object.keys(paymentSettings).length > 0 && Object.keys(chargeDetail).length > 0){
    return(
      <>
        <div 
          className="paypal-button-wrap"
          style={ isLoading ? {zIndex: -1, position: 'relative', pointerEvents: 'none'} : {zIndex: 0, position: 'relative', pointerEvents: 'all'} }>
          <PayPalButton
            amount={countAmountValue()}
            onButtonReady={ () => setTimeout(() => setIsLoading(false), 200) }
            currency={paymentSettings.currency_code.toUpperCase()}
            options={ { clientId: chargeDetail.paypal.client_id, currency: paymentSettings.currency_code.toUpperCase() }}
            style={{ layout: "horizontal", color: 'white', tagline: 'false', size: 'responsive' }}
            onClick = { (data, actions) => paypalOnClick(data, actions) }
            createOrder = { (data, actions) => paypalCreateOrder(data, actions) }
            onError = { (err) => errorPaypalPayment(err) }
            onCancel = { (data) => cancelPaypalPayment(data) } 
            onSuccess = { (details, data) => paypalSuccess(details, data) } />
        </div>
      </>
    );
  }
});

export default Paypal;